// Drink swap helpers — used by the Scorecard's SWAP chip and DD Mode.

/**
 * Given a drink string, return a non-alcoholic alternative that still
 * matches the "sips to finish" vibe of the original.
 */
export function getNonAlcoholicVersion(drink) {
  const d = String(drink || '').toLowerCase();
  if (!d) return 'Club soda';
  if (
    d.includes('beer') ||
    d.includes('lager') ||
    d.includes('ale') ||
    d.includes('ipa') ||
    d.includes('stout') ||
    d.includes('guinness') ||
    d.includes('pilsner') ||
    d.includes('draft') ||
    d.includes('pint')
  ) {
    return 'Root beer';
  }
  if (
    d.includes('shot') ||
    d.includes('tequila') ||
    d.includes('jager') ||
    d.includes('fireball') ||
    d.includes('whiskey') ||
    d.includes('bourbon') ||
    d.includes('jameson') ||
    d.includes('rum') ||
    d.includes('vodka')
  ) {
    return 'Water shot';
  }
  if (
    d.includes('wine') ||
    d.includes('merlot') ||
    d.includes('cabernet') ||
    d.includes('chardonnay') ||
    d.includes('pinot') ||
    d.includes('prosecco') ||
    d.includes('champagne')
  ) {
    return 'Grape juice';
  }
  if (d.includes('hurricane') || d.includes('daiquiri') || d.includes('margarita')) {
    return 'Virgin ' + drink;
  }
  if (
    d.includes('cocktail') ||
    d.includes('sazerac') ||
    d.includes('old fashioned') ||
    d.includes('manhattan') ||
    d.includes('negroni') ||
    d.includes('martini')
  ) {
    return 'Mocktail';
  }
  return 'Club soda';
}

/** A handful of crowd-pleasing alternative drinks to swap to. */
export const DRINK_SWAP_OPTIONS = [
  { label: 'Beer', emoji: '🍺' },
  { label: 'Tequila shot', emoji: '🥃' },
  { label: 'Whiskey neat', emoji: '🥃' },
  { label: 'House cocktail', emoji: '🍸' },
  { label: 'Margarita', emoji: '🍹' },
  { label: 'Old Fashioned', emoji: '🥃' },
  { label: 'Glass of wine', emoji: '🍷' },
  { label: 'Espresso martini', emoji: '🍸' },
];
